import { TopolDividerBlock } from "@/schemas/template/blocks/dividerBlockSchema";
import calcWidth from "./helpers";
import { v4 as uuidv4 } from "uuid";
import { useMjmlStore } from "@/stores/mjmlStore";

export default {
  getData(
    state: any,
    props: { sectionIndex: number; columnIndex: number }
  ): TopolDividerBlock {
    const mjmlStore = useMjmlStore();
    const attributes: TopolDividerBlock["attributes"] = {
      "border-color":
        mjmlStore.getBaseAttrString("mj-divider", "border-color") || "#000000",
      "border-style":
        mjmlStore.getBaseAttrString("mj-divider", "border-style") || "solid",
      "border-width":
        mjmlStore.getBaseAttrString("mj-divider", "border-width") || "1px",
      padding:
        mjmlStore.getBaseAttrString("mj-divider", "padding") || "10px 10px",
      "padding-top":
        mjmlStore.getBaseAttrString("mj-divider", "padding-top") || "10px",
      "padding-right":
        mjmlStore.getBaseAttrString("mj-divider", "padding-right") || "10px",
      containerWidth: calcWidth(
        state.mjml.children[0].attributes["containerWidth"],
        state.mjml.children[0].children[props.sectionIndex].children[
          props.columnIndex
        ].attributes["width"]
      ),
    };

    const bgColor = mjmlStore.getBaseAttrString(
      "mj-divider",
      "container-background-color"
    );
    if (bgColor) {
      attributes["container-background-color"] = bgColor;
    }

    const gradient = mjmlStore.getBaseAttrString(
      "mj-divider",
      "container-gradient"
    );
    if (gradient) {
      attributes["container-gradient"] = gradient;
    }

    return {
      uid: uuidv4(),
      tagName: "mj-divider",
      attributes,
    };
  },
};
